import { Injectable, inject } from '@angular/core'
import { MatchedOffer } from '@tradecafe/types/core'
import { ModalService } from 'src/shared/modal/modal.service'
import {
  MatchedOfferBidHistoryOverlayComponent,
  MatchedOfferBidHistoryOverlayOptions,
} from './matched-offer-bid-history-overlay.component'

@Injectable()
export class MatchedOfferBidHistoryOverlayService {
  private modal = inject(ModalService)


  showBidHistory(matchedOffer: MatchedOffer) {
    return this.modal.openDialog<
      MatchedOfferBidHistoryOverlayComponent,
      MatchedOfferBidHistoryOverlayOptions,
      void
    >(
      MatchedOfferBidHistoryOverlayComponent,
      { matchedOffer },
      { panelClass: ['tc-dialog', 'modal-lg'], width: null, maxWidth: null },
    )
  }
}
